<div class="modal-header">
    <h4 class="modal-title" id="modal-title">{{options?.title || 'Are you sure?'}}</h4>
</div>
<div class="modal-body">
    <div [innerHTML]="(options?.body | basicMarkdown) || 'Please confirm your action!'"></div>
    <div *ngIf="inputOptions?.predefinedTexts" class="mt-3">
        <div *ngFor="let text of inputOptions.predefinedTexts; let l = last"
             (click)="togglePredefinedText(text)"
             class="p-3 rounded cursor-pointer {{value?.includes(text) ? 'bg-primary text-white' : 'bg-lighter'}}"
             [class.mb-1]="!l">
            {{text}}
        </div>
    </div>
    <div *ngIf="inputOptions?.predefinedStructuredResponses" class="mt-3">
        <div *ngFor="let group of inputOptions.predefinedStructuredResponses; let l = last"
             class="p-3 rounded {{value?.includes(group.title) ? 'bg-primary text-white' : 'bg-lighter'}}"
             [class.mb-1]="!l">
            <div class="small strong mb-2">{{group.title}}</div>
            <div *ngFor="let option of group.options">
                <app-toggle [ngModel]="value?.includes(option)"
                            (ngModelChange)="togglePredefinedResponse(option)"
                            [label]="option"
                            size="sm"
                            class="cursor-pointer">
                </app-toggle>
            </div>
        </div>
    </div>
    <div class="mt-3">
        <ng-select *ngIf="list?.length && !listOptions?.radio"
                   [items]="list"
                   bindLabel="displayName"
                   bindValue="value"
                   [(ngModel)]="value">
        </ng-select>
        <div *ngIf="list?.length && listOptions?.radio">
            <div *ngFor="let item of list" class="custom-control custom-radio mb-2">
                <input type="radio"
                       [id]="'radio-' + item.value"
                       name="radio-options"
                       class="custom-control-input"
                       [value]="item.value"
                       [(ngModel)]="value">
                <label class="custom-control-label" [for]="'radio-' + item.value">{{item.displayName}}</label>
            </div>
        </div>
        <datepicker-select *ngIf="dateOptions?.date"
                           [(date)]="value"
                           controlClass="form-control"
                           format="text">
        </datepicker-select>
        <ng-container *ngIf="inputOptions?.input">
            <input *ngIf="!inputOptions.rows"
                   [(ngModel)]="value"
                   [placeholder]="inputOptions.input"
                   required
                   type="text"
                   class="form-control">
            <textarea *ngIf="inputOptions.rows"
                      [(ngModel)]="value"
                      [placeholder]="inputOptions.input"
                      [rows]="inputOptions.rows"
                      [required]="!inputWithEmptyOptions.allowEmpty"
                      class="form-control">
            </textarea>
        </ng-container>
        <!-- TODO: clean up valueFunction handling after it's been cleaned up in AdvancedInputComponent -->
        <app-advanced-input *ngIf="searchOptions?.searchAPIOptions"
                            type="select"
                            [ngModel]="value"
                            (ngModelChange)="value = searchOptions.searchAPIOptions.valueFunction ? searchOptions.searchAPIOptions.valueFunction($event) : value"
                            [bindValue]="searchOptions.searchAPIOptions.valueFunction ? null : 'id'"
                            [asyncOptionsAPI]="searchOptions.searchAPIOptions"
                            [placeholder]="searchOptions.placeholder"
                            [clearable]="false"
                            class="custom-select">
        </app-advanced-input>
    </div>
</div>
<div class="modal-footer d-flex"
     [class.flex-column]="confirmBtns?.length > 1"
     [class.align-items-stretch]="confirmBtns?.length > 1">
    <button (click)="respond(false)"
            *ngIf="!(options?.showCancelBtn === false)"
            type="button"
            class="btn btn-outline-secondary"
            [class.m-0]="confirmBtns?.length > 1"
            [class.mt-2]="confirmBtns?.length > 1"
            [class.order-1]="confirmBtns?.length > 1">
        Cancel
    </button>
    <button *ngIf="!confirmBtns"
            (click)="respond(true)"
            [disabled]="isDisabled()"
            type="button"
            class="btn btn-{{confirmBtn?.colorClass || 'danger'}}">
        {{confirmBtn?.text || 'OK'}}
    </button>
    <button *ngFor="let btn of confirmBtns; let f = first"
            (click)="respond(btn.confirmValue || true)"
            [disabled]="isDisabled()"
            type="button"
            class="btn btn-{{btn.colorClass || 'danger'}}"
            [class.m-0]="confirmBtns.length > 1"
            [class.mt-2]="!f && confirmBtns.length > 1"
            [attr.data-test-id]="btn.dataTestId">
        {{btn.text || 'OK'}}
    </button>
</div>
